import { useNavigate } from "react-router-dom";
import { CreditCard, Envelope, Lock, Person, Phone, PinMap } from "react-bootstrap-icons";
import { useContext, useState } from "react";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { useEffect } from "react";
import { config } from "../../constants/config";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";



export default function AddUser() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [fetching, setFetching] = useState(false);

    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");
    const [confirmpass, setConfirmpass] = useState("");
    const [nom, setNom] = useState("");
    const [cni, setCni] = useState("");
    const [email, setEmail] = useState("");
    const [tel, setTel] = useState("");
    const [prenom, setPrenom] = useState("");
    const [nationalite, setNationnalite] = useState("");
    const [type, setType] = useState('');
    const [client, setClient] = useState('');
    const [typecompte, setTypecompte] = useState([]);
    const [clientlist, setClientList] = useState([]);
    const [logo, setLogo] = useState('');
    const [logoprev, setLogoprev] = useState('/assets/imgs/blank.png');


    const [soustraitant, setSoustraitant] = useState('');
    const [agent, setAgent] = useState("");
    const [ssoustraitantsList, setSsoustraitantsList] = useState([]);
    const [agentssList, setAgentsList] = useState([]);
    const [opt, setopt] = useState({ label: "Système", value: 3 });

    const optionlist = [
        // { label: "Agent", value: 1 },
        // { label: "Sous-traitant", value: 2 },
        { label: "Système", value: 3 },
    ]

    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showWarningMessage = (msg) => {
        toast.warning(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        setLogo(file)
        TransformeLogo(file);
        // console.log("recto prev", rectoprev)
    };

    const TransformeLogo = (file) => {
        const reader = new FileReader();

        if (file) {
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                setLogoprev(reader.result);
            };
        } else {
            setLogoprev("/assets/imgs/no-image.png");
        }
    };

    const getTypeCompte = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded);

        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns?nomtab=typeutilisateur&page=1&limit=100000`, requestOptions).then((response) => {

            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.lib, value: element.code });
                        });

                        let clientarraydata2 = [];
                        await clientarray.forEach(element => {
                            if (element.abrev !== "superadmin") {
                                clientarraydata2.push({ label: element.lib, value: element.code });
                            }
                        });

                        if (user?.isFullAction) {
                            setTypecompte(clientarraydata);
                        } else {
                            setTypecompte(clientarraydata2)
                        }
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("get departement list", "error")
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("get staut erreur", "error");
            }

        }).catch((err) => {
            console.log("cash error", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getClientList = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded);

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/customers`, requestOptions).then((response) => {

            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;
                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.nom, value: element.code });
                        });

                        let clientarraydata2 = [];
                        await clientarray.forEach(element => {
                            if (element.abr !== "WLC") {
                                clientarraydata2.push({ label: element.nom, value: element.code });
                            }
                        });

                        if (user?.isFullAction) {
                            setClientList(clientarraydata);
                        } else {
                            setClientList(clientarraydata2);
                            // setClient({label: clientarraydata2[0].label, value: clientarraydata2[0].value });
                        }
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("server error", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error", err);
            }

        }).catch((err) => {
            // console.log("cash error", err);
        });
    }

    function generatePassword() {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var password = '';
        for (let i = 0; i < 8; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            password += characters[randomIndex];
        }
        return password;
    }

    const setPasswordgenereted = (optionval) => {
        const newPass = generatePassword();
        if (optionval["value"] === 1 || optionval["value"] === 2) {
            setPassword(newPass);
            setConfirmpass(newPass);
        } else {
            setPassword("");
            setConfirmpass("");
        }

        // console.log("new password: ", newPass);
    }


    // comportements
    useEffect(() => {
        getTypeCompte();
        getClientList();
    }, [])

    const handleSubmit = async (e) => {

        e.preventDefault();

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();

        urlencoded.append("numcni", cni);
        urlencoded.append("nom", nom);
        if (prenom) urlencoded.append("prenom", prenom);
        if (logo || logoprev !== "/assets/imgs/no-image.png" || logoprev !== "/assets/imgs/blank.png") urlencoded.append("photo", logoprev);
        // urlencoded.append("nationalite", nationalite);
        urlencoded.append("email", email);
        urlencoded.append("typeutilisateur", type["value"]);
        urlencoded.append("codeclient", user?.isFullAction ? client["value"] : user?.client);
        urlencoded.append("numtel", "+237"+tel);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users`, requestOptions).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else if (data?.body?.msg === "numtelexistant") {
                            setFetching(false);
                            showWarningMessage("Ce numéro de téléphone est déjà utilisé par un autre utilisateur.");
                        } else if (data?.body?.msg === "numcniexistant") {
                            setFetching(false);
                            showWarningMessage("Ce numéro de CNI est déjà utilisé par un autre utilisateur.");
                        } else if (data?.body?.msg === "numpasseportexistant") {
                            setFetching(false);
                            showWarningMessage("Ce numéro de passeport est déjà utilisé par un autre utilisateur.");
                        } else if (data?.body?.msg === "emailexistant") {
                            setFetching(false);
                            showWarningMessage("Cet email est déjà utilisé par un autre utilisateur.");
                        } else {
                            setFetching(false);
                            showErrorMessage(textes.fr.requestfail);
                        }
                    } else {
                        let body = data?.body?.data;
                        await handleSubmitAccount(body?.creerutilisateur);
                        setFetching(false);
                        navigate(-1);
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage(config.texts.unavailblemsg);
            setFetching(false);
        });
    }

    const handleSubmitAccount = async (codeuser) => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        urlencoded.append("nom", `${nom} ${prenom}`);
        urlencoded.append("login", login);
        urlencoded.append("mdp", password);
        urlencoded.append("codeutilisateur", codeuser);
        urlencoded.append("defaut", false);
        urlencoded.append("edit", true);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/accounts`, requestOptions).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else if (data?.body?.msg === "loginexistant") {
                            setFetching(false);
                            showWarningMessage("Ce login est déjà utilisé par un autre compte.");
                        }else {
                            setFetching(false);
                            showErrorMessage(textes.fr.requestfail);
                        }
                    } else {
                        // if (email) {
                        //     await handleSendMail(config.mailfrom, email, "Identifiants de connexion", "Nom d'utilisateur: " + login + " \nMot de passe: " + password + "\n\nMerci")
                        // }
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage(textes.fr.serviceunavaillable);
            setFetching(false);
        });
    }

    const handleSendMail = async (from, to, subject, text) => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        if (from) urlencoded.append("from", from);
        if (to) urlencoded.append("to", to);
        if (subject) urlencoded.append("subject", subject);
        if (text) urlencoded.append("text", text);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/mail`, requestOptions).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setFetching(false);
                            showErrorMessage(textes.fr.requestfail);
                        }
                    } else {
                        
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage(textes.fr.serviceunavaillable);
            setFetching(false);
        });
    }


    // affichages
    return (
        <div className="container-fluid">
            <h1 className="h4 mb-4 font-weight-bold text_primary">Users</h1>
            <div className="row">
                <div className="col-md-12">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3">
                            <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                <i className="fa fa-reply"></i> <span>Retour</span>
                            </button>
                            <h6 className="m-0 ">User's informations</h6>
                        </div>
                        <div className="card-body">
                            <form style={{ width: "100%" }} onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <div className="row">
                                            <div className="col-md-12 mb-2">
                                                <label htmlFor="logo" className="form-label">Picture</label>
                                                <input className="form-control" type="file" id="logo" onChange={handleLogoChange} />
                                            </div>
                                            <div className="col-md-12 mb-1">
                                                <img alt="" src={logoprev} className="rounded" style={{ width: "100%" }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-8 mb-3">
                                        <div className="row">
                                            {user?.isFullAction && <div className="col-md-6 mb-3">
                                                <label htmlFor="client" className="mb-1">Client</label>
                                                <Select
                                                    id="client"
                                                    name="client"
                                                    placeholder="Selectionner"
                                                    options={clientlist}
                                                    value={client}
                                                    onChange={(selected) => {
                                                        setClient(selected);
                                                    }}
                                                />
                                            </div>}
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="typeuser" className="mb-1">Type d'utilisateur</label>
                                                <Select
                                                    id="typeuser"
                                                    name="typeuser"
                                                    placeholder="Selectionner"
                                                    options={optionlist}
                                                    value={opt}
                                                    onChange={(selected) => {
                                                        setopt(selected);
                                                        setPasswordgenereted(selected);
                                                        setAgent("");
                                                        setSoustraitant("");
                                                        setNom("");
                                                        setPrenom("");
                                                        setNationnalite("");
                                                        setCni("");
                                                        setTel("");
                                                        setEmail("");
                                                        setLogin("");
                                                        setLogoprev('/assets/imgs/no-image.png');
                                                    }}
                                                />
                                            </div>
                                            {(opt && opt["value"] === 1) && <div className="col-md-12 mb-3">
                                                <label htmlFor="agent" className="mb-1">Agent</label>
                                                <Select
                                                    id="agent"
                                                    name="agent"
                                                    placeholder="Selectionner"
                                                    options={agentssList}
                                                    value={agent}
                                                    onChange={(selected) => {
                                                        setAgent(selected);
                                                        setNom(selected["nom"]);
                                                        setPrenom(selected["prenom"]);
                                                        setNationnalite(selected["libnation"]);
                                                        setCni(selected["numpi"]);
                                                        setTel(selected["numtel"]);
                                                        setEmail(selected["email"]);
                                                        setLogin(selected["matricule"]);
                                                        setLogoprev(selected["photo"] !== null ? selected["photo"] : '/assets/imgs/blank.png');
                                                    }}
                                                />
                                            </div>}
                                            {(opt && opt["value"] === 2) && <div className="col-md-6 mb-3">
                                                <label htmlFor="soustraitant" className="mb-1">Sous-traitant</label>
                                                <Select
                                                    id="soustraitant"
                                                    name="soustraitant"
                                                    placeholder="Selectionner"
                                                    options={ssoustraitantsList}
                                                    value={soustraitant}
                                                    onChange={(selected) => {
                                                        setSoustraitant(selected);
                                                        setNom(selected["nom"]);
                                                        setCni(selected["numpi"]);
                                                        setTel(selected["numtel"]);
                                                        setEmail(selected["email"]);
                                                        setLogin(selected["email"]);
                                                        setLogoprev(selected["logo"] !== null ? selected["logo"] : '/assets/imgs/no-image.png');
                                                    }}
                                                />
                                            </div>}
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="noms" className="mb-1">Firstname</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="noms">
                                                        <Person />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Enter user firstname"
                                                        value={nom}
                                                        onChange={(e) => setNom(e.target.value)}
                                                        disabled={(opt["value"] === 1 || opt["value"] === 2) ? true : false}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="abrev" className="mb-1">Lastname</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="abrev">
                                                        <Person />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Enter user's lastname"
                                                        value={prenom}
                                                        onChange={(e) => setPrenom(e.target.value)}
                                                        disabled={(opt["value"] === 1 || opt["value"] === 2) ? true : false}
                                                    />
                                                </div>
                                            </div>
                                            {(opt && opt["value"] !== 2) && <div className="col-md-6 mb-3">
                                                <label htmlFor="nat" className="mb-1">Nationality</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="nat">
                                                        <PinMap />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Enter user's nationality "
                                                        value={nationalite}
                                                        onChange={(e) => setNationnalite(e.target.value)}
                                                        disabled={(opt["value"] === 1 || opt["value"] === 2) ? true : false}
                                                    />
                                                </div>
                                            </div>}
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="cni" className="mb-1">Identity card number</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="cni">
                                                        <CreditCard />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Enter user's identity card number "
                                                        value={cni}
                                                        onChange={(e) => setCni(e.target.value)}
                                                        disabled={(opt["value"] === 1 || opt["value"] === 2) ? true : false}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="email" className="mb-1">Email address</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="email">
                                                        <Envelope />
                                                    </span>
                                                    <input type="email"
                                                        className="form-control"
                                                        placeholder="Enter user's email address"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        disabled={(opt["value"] === 1 || opt["value"] === 2) ? true : false}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="tel1" className="mb-1">Phone number</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="tel1">
                                                        <Phone />
                                                    </span>
                                                    <input type="tel"
                                                        className="form-control"
                                                        placeholder="Ex: 690000000"
                                                        value={tel}
                                                        onChange={(e) => setTel(e.target.value)}
                                                        disabled={(opt["value"] === 1 || opt["value"] === 2) ? true : false}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12 mb-2 mt-3">
                                                <h4>Informations du compte</h4>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="typecompte" className="mb-1">Type of account</label>
                                                <Select
                                                    id="typecompte"
                                                    name="typecompte"
                                                    options={typecompte}
                                                    value={type}
                                                    onChange={(selected) => { setType(selected); }}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="login" className="mb-1">Username</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="login">
                                                        <Person />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Enter account username"
                                                        value={login}
                                                        onChange={(e) => setLogin(e.target.value)}
                                                        disabled={(opt["value"] === 1 || opt["value"] === 2) ? true : false}
                                                    />
                                                </div>
                                            </div>
                                            {(opt && opt["value"] === 3) && <div className="col-md-6 mb-3">
                                                <label htmlFor="pass" className="mb-1">Password</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="pass">
                                                        <Lock />
                                                    </span>
                                                    <input type="password"
                                                        className="form-control"
                                                        placeholder="Enter account password"
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                    />
                                                </div>
                                            </div>}
                                            {(opt && opt["value"] === 3) && <div className="col-md-6 mb-3">
                                                <label htmlFor="confirmpass" className="mb-1">Confirm password</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="confirmpass">
                                                        <Lock />
                                                    </span>
                                                    <input type="password"
                                                        className="form-control"
                                                        placeholder="Enter password confirmation"
                                                        value={confirmpass}
                                                        onChange={(e) => setConfirmpass(e.target.value)}
                                                    />
                                                </div>
                                            </div>}
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <button type="submit"
                                            title="Add new user"
                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                            disabled={nom && nationalite && cni && email && tel && type["value"] && login && password && password === confirmpass && (login !== password) ? false : true}
                                        >
                                            <i className="fa fa-check mr-2"></i>
                                            <span>Add user</span> {fetching && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}